import React from "react";
import {Auth0Provider} from "@auth0/auth0-react";
import AuthenticationRouter from "./AuthenticationRouter";

export default function App() {

  return (
      <Auth0Provider
          useRefreshTokens
          cacheLocation="localstorage"
          domain={process.env.AUTH0_DOMAIN}
          clientId={process.env.AUTH0_CLIENTID}
          authorizationParams={{
            redirect_uri: process.env.AUTH0_LOGIN_CALLBACK_URI,
            audience: process.env.AUTH0_CONNECT_API_AUDIENCE,
            scope: "offline_access read:api_keys"}}>

        <AuthenticationRouter />
      </Auth0Provider>
  )

}